export default __webpack_public_path__ + "static/media/linkedin-white.7845b108.svg";